import React from "react";
import { createContext } from "use-context-selector";
import { useAppContextState } from "app/@hooks";

const Context = createContext({});

const initialState = { totalAlertsNotifications: [], isOpenAlertsDrawer: false, isLoading: false }

export function AppNotificationsDrawerProvider({ children }) {
    const { state, replaceState, resetState, updateState } = useAppContextState(initialState);

    return <Context.Provider value={{ state, replaceState, resetState, updateState }}>
        {children}
    </Context.Provider>
}

export default Context;